<template>
  <div>
    <download-excel
      style="display: inline-block"
      :data="data1"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="套餐统计表.xls"
    >
      <a-button
        type="primary"
        :style="{ margin: '0 0 24px 0', display: 'inline-block' }"
      >
        Excel导出
      </a-button>
    </download-excel>
    <span style="margin-left: 20px;">当前查询订单查询合计金额：{{ sumPrice }}</span>
    <a-table
      :columns="columns"
      :row-key="record => record.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
    <template slot="goodsType" slot-scope="text,record">
      <span v-if="record.goodsType === 654">代币套餐</span>
      <span v-if="record.goodsType === 655">门票套餐</span>
    </template>

    </a-table>
  </div>
</template>
<script>
import { packageStatistics } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
const columns = [

  {
    title: "订单类型",
    dataIndex: "goodsType",
    align: "center",
    scopedSlots: { customRender: "goodsType" }
  },
  {
    title: "订单笔数",
    dataIndex: "orderCount",
    align: "center"
  },
  {
    title: "套餐上架单价",
    dataIndex: "unitPrice",
    align: "center"
  },
  {
    title: "套餐名称",
    dataIndex: "goodsName",
    align: "center"
  },
  {
    title: "套餐销售数量",
    dataIndex: "totalQuantity",
    sorter: true,
    align: "center"
  },
  // {
  //   title: "订单支付价",
  //   dataIndex: "pricePay",
  //   sorter: true,
  //   align: "center"
  // },
  
  {
    title: "实际订单支付总价",
    dataIndex: "orderPricePay",
    sorter: true,
    align: "center"
  },
  {
    title: "套餐规格总价",
    dataIndex: "totalPrice",
    sorter: true,
    align: "center"
  },
  {
    title: "差额",
    dataIndex: "integralPrice",
    sorter: true,
    align: "center"
  },
  
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      json_fields: {
        订单类型: "goodsType",
        订单数量: "orderCount",
        套餐上架单价: "unitPrice",
        套餐名称: "goodsName",
        // 订单支付价:"pricePay",
        套餐销售数量: "totalQuantity",
        实际订单支付总价: "orderPricePay",
        套餐规格总价: "totalPrice",
        差额:"integralPrice"
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: total => `共 ${total} 条`,
        pageSize: 10
      },
      loading: false,
      columns,
      visible: false,
      sumPrice: 0,
    };
  },
  props: ["formInline"],
  mounted() {
    this.getAlreadyPayData();
  },

  methods: {
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const goodsType = this.formInline.goodsType;
      const endDate = this.formInline.endDate;
      const startDate = this.formInline.startDate;
      
      // 第一步：获取总数量，判断数据规模
      const countRes = await packageStatistics(goodsType, endDate, startDate, 1, 1);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        // 数据量较小，一次性获取
        const res = await packageStatistics(goodsType, endDate, startDate, 1, totalCount);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const res = await packageStatistics(goodsType, endDate, startDate, page, pageSize);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },
    topage(routerpath, record) {
      console.log(record);
      this.$router.push(routerpath);
    },
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.data  = [];
      this.sumPrice=0;
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      packageStatistics(
        this.formInline.goodsType,
        this.formInline.endDate,
        this.formInline.startDate,
        this.pagination.current, //当前页
        this.pagination.pageSize, //每页条数
      ).then(res => {
        this.loading = false;
        console.log(res);
        if(res.data == null){
          message.info("暂无数据")
        }
        this.pagination.total = res.count;
        this.data = res.data;
        this.sumPrice = res.data[0].sumPrice;
      });
    },
    getAlreadyPayData() {
      this.loading = true;
      this.data  = [];
      this.sumPrice=0;
      packageStatistics(
        this.formInline.goodsType,
        this.formInline.endDate,
        this.formInline.startDate,
        this.pagination.current, //当前页
        this.pagination.pageSize, //每页条数
      ).then(res => {
        console.log(res);
        if(res.data == null){
          message.info("暂无数据")
        }else{
          this.pagination.total = res.count;
          this.data = res.data;
          this.sumPrice = res.data[0].sumPrice;
        }
      
        this.loading = false;
      });
    },
    // 查询
    query() {
      console.log("e", this.formInline);
      this.data  = [];
      this.sumPrice=0;
      this.loading = true;
      packageStatistics(
        this.formInline.goodsType,
        this.formInline.endDate,
        this.formInline.startDate,
        this.pagination.current, //当前页
        this.pagination.pageSize, //每页条数
      ).then(res => {
        this.loading = false;
        console.log(res);
        this.data = res.data;
        this.pagination.total = res.count;
        this.sumPrice = res.data[0].sumPrice;
      });
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/orderManagement/mallGoodOrderCount/mallGoodOrderContent.vue